import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    marginBottom: 16,
  },
  titleTextStyle: {
    fontSize: 16,
    marginBottom: 16,
    paddingHorizontal: 16,
    ...Fonts.type.bold,
  },
  emptyViewStyle: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.divider,
    paddingBottom: 17,
  }),
  emptyTextStyle: {
    fontSize: 14,
    lineHeight: 18,
    marginLeft: 18.53,
    flex: 1,
  },
});
